import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import AuthButton from "../AuthButton/AuthButton";
import Input from "../Input/Input";
import { ClientGenerateReport, POPUP } from "../../Actions/actions";
import { BaseUrl } from "../../BaseUrl/BaseUrl";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { toast } from "react-toastify";
import CustomToast from "../CustomToast/CustomToast";

const ReportManagementModalClient = ({ isOpen, onClose, heading }) => {
  const dispatch = useDispatch();

  const { loginData } = useSelector((state) => state.userReducer);

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    type: "",
    startDateTime: "",
    endDateTime: "",
  });
  const [formData, setFormData] = useState({
    clientId: "",
    name: "",
    type: "",
    startDateTime: "",
    endDateTime: "",
  });

  const ReportOption = [
    { value: "call-logs", label: "Call Logs Report" },
    { value: "lead-pipeline-report", label: "Lead Pipeline Report" },
    { value: "prospect-leads", label: "Prospect Lead Report" },
    { value: "business-loss", label: "Business Lost Report" },
    { value: "visit", label: "Visit Report" },
    { value: "performance", label: "Performance Report" },
  ];

  useEffect(() => {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 7);

    setFormData({
      startDateTime: sevenDaysAgo.toISOString().split("T")[0],
      endDateTime: today.toISOString().split("T")[0],
    });
  }, [isOpen]);

  const validateForm = () => {
    let valid = true;
    let newErrors = {
      reportName: "",
      reportType: "",
      startDateTime: "",
      endDateTime: "",
    };

    if (!formData.name) {
      newErrors.reportName = "Report name is required";
      valid = false;
    }
    if (!formData.type) {
      newErrors.reportType = "This field is required";
      valid = false;
    }
    if (!formData.startDateTime) {
      newErrors.startDate = "Start date is required";
      valid = false;
    }
    if (!formData.endDateTime) {
      newErrors.endDate = "End date is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormData({ ...formData, clientId: loginData?.clientData?.id });
    console.log(formData, "form Data is here");
    if (!validateForm()) {
      return;
    } else {
      dispatch(
        ClientGenerateReport(loginData?.accessToken, { ...formData, clientId: loginData?.clientData?.id }, () => {})
      );
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-gray-900 opacity-50 fixed inset-0" onClick={onClose}></div>

      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] md:w-[40%] relative z-10">
        <button className="absolute top-7 right-5 text-gray-500 hover:text-gray-700" onClick={onClose}>
          <AiOutlineClose size={20} />
        </button>

        <h2 className="text-xl font-semibold mb-6">{heading}</h2>

        <form className="">
          <div className="w-full mr-4 mb-6">
            <Input
              type="text"
              float={true}
              name="Report Name"
              label={"Report Name*"}
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />
            {errors.reportName && <p className="text-red-500 text-sm">{errors.reportName}</p>}
          </div>

          <div className="-mt-5">
            <DropDownCustom
              selectedValue={ReportOption?.find((option) => option.value === formData.reportType)}
              handleChanges={(e) => {
                setFormData({ ...formData, type: e.value });
              }}
              options={ReportOption}
              isSearchable={false}
              label="Report Type*"
              placeholder={"Select Report Type"}
            />
            {errors.assetType && <p className="text-red-500 text-sm">{errors.assetType}</p>}
          </div>

          <div className="flex mt-6">
            <div className="w-full mr-4">
              <Input
                type="date"
                isMinimumDate={false}
                float={true}
                label={"From"}
                value={formData.startDateTime}
                name="startFrom"
                onChange={(e) => setFormData({ ...formData, startDateTime: e.target.value })}
              />
              {errors.startDateTime && <p className="text-red-500 text-sm">{errors.startDateTime}</p>}
            </div>
            <div className="w-full">
              <Input
                type="date"
                name="endTo"
                label="To"
                float
                value={formData.endDateTime}
                onChange={(e) => setFormData({ ...formData, endDateTime: e.target.value })}
              />
              {errors.endDateTime && <p className="text-red-500 text-sm">{errors.endDateTime}</p>}
            </div>
          </div>

          <div className="flex justify-end mt-6 space-x-4">
            <AuthButton
              onClick={onClose}
              className="bg-white px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-100"
              width={"20%"}
              title={"Cancel"}
            />
            {loader ? (
              <Loader />
            ) : (
              <AuthButton
                width={"20%"}
                title={"Generate"}
                onClick={handleSubmit}
                className="px-4 py-2 text-white rounded-md"
              />
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ReportManagementModalClient;
